import React from "react";

import { formatCurrency } from "../../utils";

import microscopeIcon from "../../../../../assets/images/subscriptions/microscope-line.svg";
import reactjsIcon from "../../../../../assets/images/subscriptions/reactjs-line.svg";

const DEFAULT_CATEGORY_ICONS = {
  microbiology: microscopeIcon,
  chemistry: reactjsIcon,
};

export default function ReviewTopUpBreakdown({
  categories = [],
  categoryIcons = DEFAULT_CATEGORY_ICONS,
}) {
  return (
    <div className="ReviewTopUpBreakdown">
      <div className="ReviewTopUpBreakdown__TableHead" aria-hidden>
        <span>Test Category</span>
        <span>Quantity</span>
        <span>Rate</span>
        <span>Price</span>
      </div>

      <div className="ReviewTopUpBreakdown__Categories">
        {categories.map((category, categoryIndex) => (
          <section className="ReviewTopUpBreakdown__Category" key={category.key}>
            {categoryIndex > 0 && (
              <div className="ReviewTopUpBreakdown__Divider" aria-hidden />
            )}

            <div className="ReviewTopUpBreakdown__CategoryHeader">
              <span
                className={`ReviewTopUpBreakdown__CategoryIcon ReviewTopUpBreakdown__CategoryIcon--${category.key}`}
              >
                <img
                  src={categoryIcons[category.key]}
                  alt=""
                  aria-hidden
                />
              </span>
              <h3 className="ReviewTopUpBreakdown__CategoryName">{category.name}</h3>
            </div>

            {category.items.map((item) => (
              <div className="ReviewTopUpBreakdown__Row" key={item.key}>
                <span className="ReviewTopUpBreakdown__Tier">{item.name}</span>
                <span className="ReviewTopUpBreakdown__Quantity">
                  {Number(item.quantity).toLocaleString()}
                </span>
                <span className="ReviewTopUpBreakdown__Rate">
                  {formatCurrency(item.rate)}
                </span>
                <span className="ReviewTopUpBreakdown__Price">
                  {formatCurrency(item.quantity * item.rate)}
                </span>
              </div>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
